import { instance } from 'services/api';

export const getCategories = async (setCategories, setCategoriesObj) => {
  try {
    const response = await instance.get('/api/get_categories');
    if (response.data.ok) {
      const categoriesResponse = response.data.body.categories.map(
        (cat) => cat.name,
      );
      setCategories(categoriesResponse);
      setCategoriesObj(response.data.body.categories);
    }
  } catch {
    /* empty */
  }
};

export const getSubCategories = async (setSubCategories) => {
  try {
    const response = await instance.get('/api/get_subcategories');
    if (response.data.ok)
      setSubCategories(
        response.data.body.subcategories.map((subCat) => subCat.name),
      );
  } catch {
    /* empty */
  }
};
